import { DataKeyValueStringInterface } from 'pf-frontend-common/src/module/data/key-value/string.interface';
import { JsonApiPayloadInterface } from 'pf-frontend-common/src/module/json-api/payload.interface';
import { ApiServiceInterface } from 'pf-frontend-common/src/service/api/service.interface';

import { BrokerLeadModel } from 'common/data/broker-lead/model';
import { LeadStoreCreateResponseInterface } from 'common/data/lead/store/create/response.interface';
import { objectFilterNonOrEmptyValue } from 'common/helper/object/filter/non-or-empty-value';
import { ApiEndpointServiceInterface } from 'common/service/api-endpoint/service.interface';
import { BrokerLeadStoreServiceInterface } from 'common/service/broker-lead-store/service.interface';

export class BrokerLeadStore implements BrokerLeadStoreServiceInterface {
  /**
   * API endpoint
   */
  protected endpoint: { [key: string]: DataKeyValueStringInterface } = {
    create: {
      path: this.apiEndpointService.getPath('/broker/{modelId}/lead'),
      method: 'POST',
    },
  };

  /**
   * Constructor
   */
  constructor(protected apiService: ApiServiceInterface, protected apiEndpointService: ApiEndpointServiceInterface) {}

  /**
   * @inheritDoc
   */
  public create(modelId: string, model: BrokerLeadModel): Promise<LeadStoreCreateResponseInterface> {
    // Prepare path
    const path = this.endpoint.create.path.replace('{modelId}', modelId);

    // Prepare payload
    const payload: JsonApiPayloadInterface = model.serialize();

    return this.apiService.request(this.endpoint.create.method, path, objectFilterNonOrEmptyValue(payload), true);
  }
}
